/* eslint-disable react-hooks/exhaustive-deps */
import { debounce } from 'lodash'
import { useMemo } from 'react'

export const useDebounce = (delay, callback, deps) => {
  return useMemo(() => debounce(callback, delay), deps)
}
